import { InjectionToken } from '@angular/core';

export const DEBUG_INJECTION_TOKEN = new InjectionToken<boolean>('Debug Injection Token');